import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { LandingPageComponent } from './landing-page/landing-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'en', pathMatch: 'full' },
  { path: 'undefined', redirectTo: 'en', pathMatch: 'full' },
  { path: ':lang', loadChildren: () => import('./mainlayout/mainlayout.module').then(mod => mod.MainlayoutModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
